function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-6810.57 -6725.27)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m7532.51 7169.69c-84.31 104.17-237.12 120.28-341.28 36s-120.3-237.09-36-341.27 237.09-120.29 341.27-36 120.3 237.1 36.01 341.27z",
  fill: "#f00",
  opacity: 0.24
}), /*#__PURE__*/React.createElement("path", {
  d: "m7527.41 6790.23c-125.27-101.36-309-82-410.35 43.28s-82 309 43.26 410.33 309 82 410.36-43.26 81.99-308.99-43.27-410.35zm5.1 379.46c-84.31 104.17-237.12 120.28-341.28 36s-120.3-237.09-36-341.27 237.09-120.29 341.27-36 120.3 237.1 36.01 341.27z",
  fill: "#575756"
}), /*#__PURE__*/React.createElement("path", {
  d: "m7127.2 7181.75c-.78.86-1.58 1.68-2.33 2.59l-299.87 370.53a65 65 0 1 0 101 81.77l299.84-370.53c.74-.91 1.38-1.86 2.06-2.8z",
  fill: "#575756"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m7043.09 7272.19h83.42v129.99h-83.42z",
  fill: "#f00",
  transform: "matrix(.62904908 -.77736559 .77736559 .62904908 -9886.09 1504.4)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m7027.69 7325.03h28.71v129.99h-28.71z",
  fill: "#f00",
  transform: "matrix(.62891339 -.77747537 .77747537 .62891339 -9942.92 1492.07)"
});

function SvgMurderMystery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 825.08 935.49",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMurderMystery);
export default __webpack_public_path__ + "static/media/murder-mystery.574a5697.svg";
export { ForwardRef as ReactComponent };